/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Subscriptionmodal_Primaryactiontitle3Inputs */

const en_home_subscriptionmodal_primaryactiontitle3 = /** @type {(inputs: Home_Subscriptionmodal_Primaryactiontitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to home`)
};

/**
* | output |
* | --- |
* | "Return to home" |
*
* @param {Home_Subscriptionmodal_Primaryactiontitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_subscriptionmodal_primaryactiontitle3 = /** @type {((inputs?: Home_Subscriptionmodal_Primaryactiontitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Subscriptionmodal_Primaryactiontitle3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_subscriptionmodal_primaryactiontitle3(inputs)
});
export { home_subscriptionmodal_primaryactiontitle3 as "home_subscriptionModal_primaryActionTitle" }